import { render } from "./EventList.vue?vue&type=template&id=c60f9ec0&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=c60f9ec0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c60f9ec0"

export default script